/**
* 头部菜单
*/ 
<template>
  <el-menu class="el-menu-demo" mode="horizontal"  text-color="#333" active-text-color="#333">
    <el-button class="buttonimg">
      <!-- <img class="showimg" :src="collapsed?imgsq:imgshow" @click="toggle(collapsed)"> -->
    </el-button>
    <el-submenu index="2" class="submenu">
      <!-- <template slot="title">{{user.userRealName}}</template> -->
      <template slot="title" v-if="user.is_superuser">超级管理员</template>
      <template slot="title" v-else>{{user.username}}</template>
      <!-- <el-menu-item index="2-1">设置</el-menu-item>
      <el-menu-item @click="content()" index="2-2">个人中心</el-menu-item> -->
      <el-menu-item @click="exit()" index="2-3">退出</el-menu-item>
    </el-submenu>
  </el-menu>
</template>
<script>
import { loginout,adminu} from '../api/userMG'
export default {
  name: 'navcon',
  data() {
    return {
      collapsed: true,
      imgshow: require('../assets/img/show.png'),
      imgsq: require('../assets/img/sq.png'),
      user: {}
    }
  },
  // 创建完毕状态(里面是操作)
  created() {
    this.getUser()
  },
  methods: {
    getUser(){
      adminu()
            .then(res => {
              // console.log(res,33333)
              if (res.message=="success") {
                //如果请求成功就让他2秒跳转路由
                // this.user = JSON.parse(localStorage.getItem('userdata'))
                this.user = res.data;
              } else {
                // console.log(res.detail,222222222)
                if(res.detail=='无效的令牌格式'){
                  this.$message.error(res.detail)
                  setTimeout(() => {
                  this.$store.commit('logout', 'false')
                  this.$router.push({ path: '/login' })
                  // this.$message({
                  //   type: 'success',
                  //   message: '已退出登录!'
                  // })
                 }, 1000)
                }else{
                this.$message.error(res.detail)
                }
                return false
              }
            })
            .catch(err => {
              // 获取图形验证码
              // this.getcode()
              this.$message.error('登录已失效')
              // this.$message.error(err.detail)
              setTimeout(() => {
                  this.$store.commit('logout', 'false')
                  this.$router.push({ path: '/login' })
                  // this.$message({
                  //   type: 'success',
                  //   message: '已退出登录!'
                  // })
                 }, 300)
              //this.$message.error('退出失败，请稍后再试！')
            })
    },
    // 退出登录
    exit() {
      this.$confirm('退出登录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          setTimeout(() => {
                  this.$store.commit('logout', 'false')
                  this.$router.push({ path: '/login' })
                  this.$message({
                    type: 'success',
                    message: '已退出登录!'
                })
         }, 1000)
        //   loginout()
        //     .then(res => {
        //       // console.log(res.data,22222222)
        //       if (res.message=="success") {
        //         //如果请求成功就让他2秒跳转路由
        //         setTimeout(() => {
        //           this.$store.commit('logout', 'false')
        //           this.$router.push({ path: '/login' })
        //           this.$message({
        //             type: 'success',
        //             message: '已退出登录!'
        //           })
        //         }, 1000)
        //       } else {
        //         if(res.detail=='令牌已过期'){
        //           setTimeout(() => {
        //           this.$store.commit('logout', 'false')
        //           this.$router.push({ path: '/login' })
        //           // this.$message({
        //           //   type: 'success',
        //           //   message: '已退出登录!'
        //           // })
        //          }, 1000)
        //         }else{
        //         this.$message.error(res.detail)
        //         }
        //         return false
        //       }
        //     })
        //     .catch(err => {
        //       // 获取图形验证码
        //       // this.getcode()
        //       this.$message.error('退出失败，请稍后再试！')
        //     })
         })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    // 切换显示
    toggle(showtype) {
      this.collapsed = !showtype
      this.$root.Bus.$emit('toggle', this.collapsed)
    }
  }
}
</script>
<style scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
}
.submenu {
  float: right;
}
.buttonimg {
  height: 60px;
  background-color: transparent;
  border: none;
}
.showimg {
  width: 26px;
  height: 26px;
  position: absolute;
  top: 17px;
  left: 17px;
}
.showimg:active {
  border: none;
}
</style>


// WEBPACK FOOTER //
// src/components/navcon.vue